// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ead48c6c","703":"6741dcd1","787":"596f3d77"}[chunkId] + ".chunk.js";
};